export const ABORTED_STATUS_CODE = 499;
export const ABORTED_STATUS_TEXT = 'AbortError';
